const COLORS = {
  white: '#fff',
  background: '#eceff1',
  color: '#123',
  lightColor: '#567',
  red: '#d62d20'
}

export default COLORS
